import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry } from 'lib/components';
import { dateFormat, ReactNodeGenerator, promiseStates } from 'lib/helpers';
import {pagedListResponseUtils, PagedListResponse} from '../../../domain';
import { EssayTeacherListSceneStore } from './EssayTeacherListSceneStore';
import { EssayViewModel, EssayTeacherListResponse, EssayTeacherListResponseItem } from '../EssayModels';
import Rating from '@mui/material/Rating';
import { routes } from 'pages/Routes';
import classNames from 'classnames';
import { EssayStatus } from 'domain/enums';
import { EssaySelect } from 'lib/components/select/EssayStatusSelect';

@observer
export class EssayTeacherListScene extends React.Component {
    readonly store: EssayTeacherListSceneStore;

    constructor(props: any) {
        super(props);
        this.store = new EssayTeacherListSceneStore();
    }

    componentDidMount() {
        this.store.load();
    }

    *renderRows(resp: EssayTeacherListResponse): ReactNodeGenerator {
        for (const essay of resp.Items) {
            const rowClasses = classNames({
                'blink_me': essay.Status == EssayStatus.Done
            })
            yield (
                <tr className={rowClasses}>
                    <td>{resp.Items.indexOf(essay)+1}</td>
                    <td>{essay.Title}</td>
                    <td>{essay.StudentName}</td>
                    <td>
                        <span>{essay.StatusStr}</span>
                    </td>
                    <td>
                        <Rating
                            name="simple-controlled"
                            value={essay.Rating}
                            size="large"
                            readOnly
                        />
                    </td>
                    <td>{dateFormat(essay.UpdatedAt, 'wymdhm', true)}</td>
                    <td>
                        <Link className="btn btn-primary"
                            to={routes.EssayTeacherLink(essay.EssayId)}>
                            Open
                        </Link>
                    </td>
                </tr>
            );
        }
    }

    *renderer(): ReactNodeGenerator {
        const state = this.store.loader;
        yield (
            <PromiseMessage key="lesson-loader-state"
                label="Loading essay"
                state={state}
                align="right" />);

        if (promiseStates.isRejected(state)) {
            yield (
                <div className="row" key="lesson-load-action">
                    <div className="col-auto ml-auto">
                        <button type="button" className="btn btn-primary"
                            onClick={this.store.load}>
                            Load essays
                        </button>
                    </div>
                </div>
            );
        }
        if (state == null || state.isResolved == false) {
            return;
        }

        const resp = state.value;
        const essayRespons : PagedListResponse<EssayTeacherListResponseItem> =
        {      
            PageSize:8,
            CurrentPage: this.store.currentPage,
            CountRecords: state.value.AllItemsCount,
            Data: resp.Items,
        };
      
        const U = pagedListResponseUtils;
    yield (
      <div className="row" key="response-count">              
        <div className="col-sm-12 col-md-6">          
          <div className="row" key="add-form">
          <div className="col-auto ml-6">
       
          <button type="button" className="btn btn-primary"  
                   onClick={this.store.getDay} value="test" hidden ={this.store.filterDate != "Day" }>Day
            </button>
            <button type="button" className="btn btn-outline-primary"  
                onClick={this.store.getDay} value="test" hidden ={this.store.filterDate == "Day"}>Day
            </button>
           
            <button type="button" className="btn btn-primary"  
                   onClick={this.store.getWeek} value="test" hidden ={this.store.filterDate != "Week" }>Week
            </button>
            <button type="button" className="btn btn-outline-primary"
                onClick={this.store.getWeek} hidden ={this.store.filterDate == "Week"}>
            <span className="fas fa-angle"/>Week
            </button>

            <button type="button" className="btn btn-primary"  
                   onClick={this.store.getMonth} value="test" hidden ={this.store.filterDate != "Month" }>Month
            </button>
            <button type="button" className="btn btn-outline-primary"
                onClick={this.store.getMonth} hidden ={this.store.filterDate == "Month"}>
            <span className="fas fa-angle"/>Month
            </button>

            <button type="button" className="btn btn-primary"  
                   onClick={this.store.getYear} value="test" hidden ={this.store.filterDate != "Year" }>Year
            </button>
            <button type="button" className="btn btn-outline-primary"
              onClick={this.store.getYear} hidden ={this.store.filterDate == "Year"}>
            <span className="fas fa-angle"/>Year
            </button>
            </div> 
            
            <div className="md-col-sm-12 col-md-5">
                <EssaySelect value={this.store.status.value}
                              onChange={this.store.status.setValue}/>
            </div>                    
          </div>          
        </div>  
        <div className="col-auto ml-auto">       
          Total: {essayRespons.CountRecords}.
          Showing {essayRespons.CurrentPage + 1} to {Math.ceil(essayRespons.CountRecords / 8)}.
          <button type="button" className="btn btn-primary"
                  disabled={!U.hasPreviousPage(essayRespons)}
                  onClick={this.store.loadPreviousPage}>
            <span className="fas fa-angle-left"/> Prev
          </button>          
          <button type="button" className="btn btn-primary"
                  onClick={this.store.load}>
            <span className="fas fa-sync"/> Refresh
          </button>
          <button type="button" className="btn btn-primary"
                   onClick={this.store.resetResults}>
            <span className="fas fa-sync"/> Reset
          </button>
          <button type="button" className="btn btn-primary"
                  disabled={!U.hasNextPage(essayRespons)}
                  onClick={this.store.loadNextPage}>
            <span className="fas fa-angle-right"/> Next
          </button>
        </div>
      </div>);   

        yield (
            <table className="table">
                <thead>
                    <tr>
                        <th>Number</th>
                        <th>Topic</th>
                        <th>Student</th>
                        <th>Status</th>
                        <th>Rating</th>
                        <th>Updated at</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from(this.renderRows(resp))}
                </tbody>
            </table>
        );
    }

    render() {
        return Array.from(this.renderer());
    }

    componentWillUnmount() {
        this.store.dispose();
    }
}